module.exports = __webpack_public_path__ + "static/media/council-tax.8bb97bd7.svg";